<ion-card>
    <div class="title">VERBETERDE KOSTEN</div>
    <ion-row>
        <ion-col size="12" *ngIf="wizardComplete && (household$ | async) as household">
            Uit de door u ingevulde resultaten blijkt dat er een verbetering mogelijk is in uw hypotheek en / of uw levensverzekering. De totale besparing die u kunt behalen is
            <span class="green-text">€{{ household.total_saving }} per maand</span>
        </ion-col>
        <ion-col size="12" *ngIf="!wizardComplete"> In dit onderdeel van de app kunt u zien hoe veel u maximaal kunt besparen, nadat u uw informatie heeft ingevoerd. </ion-col>
    </ion-row>

    <!--    <div class="title">-->
    <!--      BETER RENDEMENT-->
    <!--    </div>-->
    <!--    <ion-row>-->
    <!--      <ion-col size="12">-->
    <!--        Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.-->
    <!--        <div class="green-text">Rendement verbetering van 10%</div>-->
    <!--      </ion-col>-->
    <!--    </ion-row>-->

    <ion-row>
        <ion-col size="12">
            <div>
                <ion-button (click)="presentModal()" style="width: 100%">NEEM CONTACT MET ONS OP</ion-button>
            </div>
        </ion-col>
    </ion-row>
</ion-card>
